/**
 * SAB-1024 — roster mutations require a completed draft.
 *
 * Adam added a player to his team in a pre-draft league. That is not cosmetic: the draft
 * pool treats a rostered player as taken, so a pre-draft add is a FREE FIRST-ROUND PICK —
 * the adder skims the board before the draft exists. In a money league it is exploitable
 * the moment a league fills.
 *
 * THE SERVER IS THE CONTROL. `checkDraftComplete` in nfl-add-drop refuses add, drop and
 * claim with a typed `DRAFT_NOT_COMPLETE`, and an API-direct probe proves it. This module
 * only decides what the UI OFFERS — hiding a button is not a security boundary, it is what
 * stops a manager being invited to do something the server will refuse.
 *
 * ── WHY draft_status AND NOT status ─────────────────────────────────────────
 *
 * `status` moves pre_draft -> drafting -> draft_completed -> in_season, and a league can
 * SIT in draft_completed while the fire-and-forget schedule flip catches up (SAB-687).
 * Adds should work there — the draft is done. `draft_status` answers the actual question.
 *
 * ── UNKNOWN MEANS NO ────────────────────────────────────────────────────────
 *
 * A null/absent draft_status refuses. That is the opposite default from the rosterability
 * filters, where being wrongly restrictive during a live draft was the greater harm. Here
 * the harm runs the other way: the closed case is the safe one, and it matches the server,
 * which also refuses on an unreadable league.
 */
export function canAcquirePlayers(draftStatus: string | null | undefined): boolean {
  return draftStatus === 'completed';
}

/** Copy for the pre-draft banner. Kept beside the predicate so they cannot drift. */
export const PRE_DRAFT_NOTICE = 'Adds open after your draft. Browse and scout in the meantime.';
